import type { BufferGeometry } from 'three';
import { hexToLinear } from '../../core/color';
import { createMeshBuilder } from '../mesh/meshBuilder';
import { box, rounded } from './lifeGeometry';

/*
 * Where a carried lantern's flame burns, in the metres the lantern is modelled in: the middle of
 * the horn. The ring it is carried by stands 0.2 m above it.
 */
export const LANTERN_FLAME = [0.3, 0.775, 0.235] as const;
export const LANTERN_RING = [0.3, 0.975, 0.235] as const;

/** A hand lantern of the kind in use before glass ones: a tin frame, panes of scraped horn, a
 *  cone over the candle and a ring to carry it by. Its sizes are estimates. */
export function buildLantern(): BufferGeometry {
  const b = createMeshBuilder();
  const [x, y, z] = LANTERN_FLAME,
    tin = hexToLinear('#4b463b'),
    horn = hexToLinear('#d9bc7c');
  box(b, tin, [x - 0.07, y - 0.105, z - 0.07], [x + 0.07, y - 0.09, z + 0.07]);
  box(b, horn, [x - 0.058, y - 0.09, z - 0.058], [x + 0.058, y + 0.09, z + 0.058]);
  for (const dx of [-1, 1])
    for (const dz of [-1, 1])
      box(
        b,
        tin,
        [x + dx * 0.064 - 0.008, y - 0.09, z + dz * 0.064 - 0.008],
        [x + dx * 0.064 + 0.008, y + 0.09, z + dz * 0.064 + 0.008]
      );
  rounded(
    b,
    tin,
    [
      { y: y + 0.09, x, z, depth: 0.075, half: 0.075 },
      { y: y + 0.15, x, z, depth: 0.022, half: 0.022 },
    ],
    6
  );
  box(b, tin, [x - 0.006, y + 0.15, z - 0.03], [x + 0.006, y + 0.2, z + 0.03]);
  return b.finish();
}
